import { useAdminLogout } from "@/hooks/useAdminLogout";
import { VNextButton } from "@/vnext/primitives";

/** Clear stale identity and query state before asking the operator to sign in. */
export function IdentitySessionSignInButton() {
  const { logout, isLoggingOut } = useAdminLogout({
    redirectTo: "/login?auth_reason=auth_session_lost",
  });
  return (
    <VNextButton
      disabled={isLoggingOut}
      onClick={() => void logout()}
      tone="secondary"
    >
      Sign in again
    </VNextButton>
  );
}
